import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";

import { getToken, setToken } from "./api";
import { Bar, Btn, Panel, Root, Strip } from "./ui";
import Rendimiento from "./Rendimiento";
import ArmarCampana from "./ArmarCampana";
import Aprobaciones from "./Aprobaciones";

const TABS = ["Rendimiento", "Armar campaña", "Aprobaciones"];

/**
 * Meta Ads: leer el rendimiento, armar campañas y aprobar cambios.
 *
 * Regla de toda la pantalla: nada de acá escribe en Meta. Lo más lejos que llega es a dejar una
 * propuesta aprobada; ejecutarla es `php artisan meta:apply`, que se corre a mano.
 *
 * Las pestañas son botones propios y no el Tabs del tema, que impone 48px de alto más su
 * indicador: en una pantalla de tablas esa altura es lo que hace falta scrollear para ver datos.
 */
export default function MetaAds() {
  const [tab, setTab] = useState(0);
  const [token, setTokenState] = useState(getToken());
  const [borrador, setBorrador] = useState(token);

  // Sin token no hay nada que mostrar: los endpoints responden 401.
  if (!token) {
    return (
      <Root>
        <div style={{ maxWidth: 560 }}>
          <Panel title="Token de acceso">
            <Strip tone="warn" style={{ marginBottom: 8 }}>
              Estos endpoints crean campañas que gastan plata, así que van detrás de un token propio
              (<code>META_ADMIN_TOKEN</code> del servidor). No viene en el build del panel a propósito:
              esto es JavaScript público y cualquier secreto compilado acá dejaría de ser secreto.
              Queda guardado en este navegador.
            </Strip>
            <TextField
              label="META_ADMIN_TOKEN"
              value={borrador}
              onChange={(e) => setBorrador(e.target.value)}
              type="password"
              fullWidth
            />
            <div style={{ marginTop: 10 }}>
              <Btn
                tone="pri"
                onClick={() => {
                  setToken(borrador.trim());
                  setTokenState(borrador.trim());
                }}
                disabled={!borrador.trim()}
              >
                guardar
              </Btn>
            </div>
          </Panel>
        </div>
      </Root>
    );
  }

  return (
    <Root>
      <Bar style={{ marginBottom: 10, borderBottom: "1px solid #E3E8F0", paddingBottom: 8 }}>
        {TABS.map((t, i) => (
          <Btn key={t} on={tab === i} onClick={() => setTab(i)}>{t}</Btn>
        ))}
        <div style={{ flex: 1 }} />
        <Btn
          onClick={() => {
            setToken("");
            setTokenState("");
            setBorrador("");
          }}
        >
          cambiar token
        </Btn>
      </Bar>

      {tab === 0 && <Rendimiento />}
      {tab === 1 && <ArmarCampana onIrAAprobaciones={() => setTab(2)} />}
      {tab === 2 && <Aprobaciones />}
    </Root>
  );
}
